/**
 * RF MCS Hub — Brand filter (T7)
 * Progressive enhancement only: every project card is server-rendered and stays
 * visible without JavaScript. This script just toggles card visibility and the
 * result count based on the selected Brand checkboxes (OR logic across brands).
 */
(function () {
  'use strict';

  function initHub(root) {
    var toggle = root.querySelector('[data-rf-mcs-hub-toggle]');
    var panel = root.querySelector('[data-rf-mcs-hub-panel]');

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var isOpen = panel.classList.toggle('is-open');
        toggle.classList.toggle('is-open', isOpen);
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    var brandCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-mcs-brand-filter]'));
    var typeCheckboxes = Array.prototype.slice.call(root.querySelectorAll('[data-mcs-type-filter]'));
    var checkboxes = brandCheckboxes.concat(typeCheckboxes);
    var cards = Array.prototype.slice.call(root.querySelectorAll('.rf-mcs-hub__card'));
    if (!checkboxes.length || !cards.length) return;

    var count = root.querySelector('[data-rf-mcs-hub-count]');
    var countSuffix = root.querySelector('[data-rf-mcs-hub-count-suffix]');
    var noResults = root.querySelector('[data-rf-mcs-hub-noresults]');
    var clearBrandButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rf-mcs-hub-clear-brand]'));
    var clearTypeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rf-mcs-hub-clear-type]'));
    var clearAllButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rf-mcs-hub-clear-all]'));

    function selectedValues(group) {
      return group
        .filter(function (checkbox) {
          return checkbox.checked;
        })
        .map(function (checkbox) {
          return checkbox.value;
        });
    }

    function pluralise(n) {
      return n === 1 ? 'project' : 'projects';
    }

    function applyFilters() {
      var brands = selectedValues(brandCheckboxes);
      var types = selectedValues(typeCheckboxes);
      var visible = 0;

      cards.forEach(function (card) {
        var brandToken = (card.getAttribute('data-mcs-brand') || '').trim();
        var typeToken = (card.getAttribute('data-mcs-type') || '').trim();
        var brandMatch = brands.length === 0 || (brandToken !== '' && brands.indexOf(brandToken) !== -1);
        var typeMatch = types.length === 0 || (typeToken !== '' && types.indexOf(typeToken) !== -1);
        var show = brandMatch && typeMatch;
        card.classList.toggle('is-hidden', !show);
        if (show) visible += 1;
      });

      if (count) count.textContent = String(visible);
      if (countSuffix) countSuffix.textContent = pluralise(visible);
      if (noResults) noResults.hidden = visible !== 0;

      clearBrandButtons.forEach(function (button) {
        button.disabled = brands.length === 0;
      });
      clearTypeButtons.forEach(function (button) {
        button.disabled = types.length === 0;
      });
      clearAllButtons.forEach(function (button) {
        button.disabled = brands.length === 0 && types.length === 0;
      });
    }

    function clearGroup(group) {
      group.forEach(function (checkbox) {
        checkbox.checked = false;
      });
      applyFilters();
    }

    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('change', applyFilters);
    });

    clearBrandButtons.forEach(function (button) {
      button.addEventListener('click', function () { clearGroup(brandCheckboxes); });
    });
    clearTypeButtons.forEach(function (button) {
      button.addEventListener('click', function () { clearGroup(typeCheckboxes); });
    });
    clearAllButtons.forEach(function (button) {
      button.addEventListener('click', function () { clearGroup(checkboxes); });
    });

    applyFilters();
  }

  var roots = document.querySelectorAll('[data-rf-mcs-hub]');
  Array.prototype.forEach.call(roots, initHub);
})();
